import script from "./ActionMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./ActionMenu.vue?vue&type=script&setup=true&lang=js"

import "./ActionMenu.vue?vue&type=style&index=0&id=76e813ef&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76e813ef"]])

export default __exports__